export const cleanObject = (pojo: Record<string, unknown>) =>
  Object.fromEntries(
    Object.entries(pojo).filter(
      ([, value]) => value !== null && value !== undefined
    )
  );
